import { Col, Layout, PageHeader, Row, Space, Typography } from 'antd';
import { Risk, RiskAction } from '../../models';
import { useContext, useEffect, useState } from 'react';
import { hasPermission } from '../../utils';
import { UserContext } from '../contexts';
import moment from 'moment';
import { RiskActionStatus } from './risk-action-status';
import { RiskActionSolutionForm } from './risk-action-solution-form';
import { RiskActionEvaluationForm } from './risk-action-evaluation-form';

export function RiskActionDetailsPage(props: { risk?: Risk; riskActionId?: string; onSaved?: () => void }) {
  const { user } = useContext(UserContext);
  const [risk, setRisk] = useState(props.risk);
  const [riskAction, setRiskAction] = useState<RiskAction>();
  const { Content } = Layout;
  const { Text } = Typography;
  const [canSolve, setCanSolve] = useState(false);
  const [canEvaluate, setCanEvaluate] = useState(false);

  const baseApiUrl = (process.env.REACT_APP_ISG_BASE_API_URL || window.location.protocol + '//' + window.location.host) + '/api/';

  useEffect(() => {
    setRisk(props.risk);
  }, [props.risk]);

  useEffect(() => {
    if (!risk) {
      return;
    }

    const solution = risk?.riskActions?.find(s => s.id === props.riskActionId);
    setRiskAction(solution);

    if (solution?.status === 'PENDING' && (hasPermission(user, 'riskActions.edit') || solution?.responsibleUser.id === user?.id)) {
      setCanSolve(true);
    } else {
      setCanSolve(false);
    }

    if (solution?.status === 'EVALUATING' && hasPermission(user, 'riskActions.evaluate')) {
      setCanEvaluate(true);
    } else {
      setCanEvaluate(false);
    }
  }, [props.riskActionId, risk, user]);

  return (
    <>
      <PageHeader title={risk?.riskNo} subTitle={<RiskActionStatus riskAction={riskAction} />} />
      <Content>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Row>
            <Col span={8}>Çözüm yöntemi</Col>
            <Col span={16}>
              {riskAction?.solutionType === 'FIVE_S'
                ? '5S'
                : riskAction?.solutionType === 'VISUAL'
                ? 'GÖRSEL'
                : riskAction?.solutionType}
            </Col>
          </Row>
          <Row>
            <Col span={8}>Alan sorumlusu</Col>
            <Col span={16}>{risk?.area?.responsibleUser?.fullNameId}</Col>
          </Row>
          <Row>
            <Col span={8}>Çözüm sorumlusu</Col>
            <Col span={16}>{riskAction?.responsibleUser?.fullNameId}</Col>
          </Row>
          {riskAction?.status === 'PENDING' && (
            <Row>
              <Col span={8}>Hedef tarih</Col>
              <Col span={16}>{moment(riskAction?.targetDate).format('DD.MM.yyyy')}</Col>
            </Row>
          )}
          {riskAction?.status !== 'PENDING' && (
            <Row>
              <Col span={8}>Gönderilme</Col>
              <Col span={16}>{moment(riskAction?.solvedAt).format('DD.MM.yyyy')}</Col>
            </Row>
          )}
          {(riskAction?.status === 'ACCEPTED' || riskAction?.status === 'REJECTED') && (
            <Row>
              <Col span={8}>{riskAction?.status === 'ACCEPTED' ? 'Onay' : 'Red'}</Col>
              <Col span={16}>
                <Space direction="vertical">
                  <span>
                    {riskAction?.evaluatedBy?.fullNameId} - {moment(riskAction?.evaluatedAt).format('DD.MM.yyyy')}
                  </span>
                  <Text type="secondary" style={{ fontSize: '0.8rem' }}>
                    {riskAction?.evaluationMessage}
                  </Text>
                </Space>
              </Col>
            </Row>
          )}
          {riskAction?.status !== 'PENDING' && (
            <Row>
              <Col span={8}>Dokümanlar</Col>
              <Col span={16}>
                {riskAction?.riskActionDocuments?.length ? (
                  <Space direction="vertical">
                    {riskAction?.riskActionDocuments.map(d => (
                      <a href={`${baseApiUrl}risks/${riskAction?.id}/documents/${d.id}`}>{d.path}</a>
                    ))}
                  </Space>
                ) : (
                  '-'
                )}
              </Col>
            </Row>
          )}
        </Space>
        {canSolve && (
          <div style={{ marginTop: '4rem' }}>
            <RiskActionSolutionForm riskAction={riskAction} onSaved={props.onSaved} />
          </div>
        )}
        {canEvaluate && (
          <div style={{ marginTop: '4rem' }}>
            <RiskActionEvaluationForm riskAction={riskAction} onSaved={props.onSaved} />
          </div>
        )}
      </Content>
    </>
  );
}
